import { Link } from 'react-router-dom';
import { useState } from 'react';

const SUBSCRIBE_FORM_URL = 'https://readdy.ai/api/form/d95mc0l7gtqne2as9ko0';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [statusMsg, setStatusMsg] = useState('');

  const handleSubscribe = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = (formData.get('website_alt') as string || '').trim();
    if (honeypot) {
      setStatus('success');
      setStatusMsg('订阅成功！感谢您的关注');
      setEmail('');
      return;
    }

    setStatus('loading');
    try {
      const res = await fetch(SUBSCRIBE_FORM_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email: formData.get('email') as string }).toString(),
      });
      const text = await res.text();
      let parsed: any = {};
      try { parsed = JSON.parse(text); } catch { /* ignore parse errors */ }
      if (res.ok && parsed?.code === 'OK') {
        setStatus('success');
        setStatusMsg('订阅成功！感谢您的关注');
        setEmail('');
      } else {
        const msg = parsed?.meta?.message || parsed?.message || '订阅失败，请稍后再试';
        setStatus('error');
        setStatusMsg(msg);
      }
    } catch {
      setStatus('error');
      setStatusMsg('网络错误，请稍后再试');
    }
  };

  return (
    <footer className="bg-primary-900 text-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="font-heading text-2xl font-black text-background-50 tracking-tight">
                51<span className="text-accent-500">爆料</span>
              </span>
            </Link>
            <p className="text-background-50/60 text-sm leading-relaxed max-w-xs">
              吃瓜爆料黑料第一站。网红翻车、擦边反差、明星八卦，24小时实时更新，真实内幕不遮掩。
            </p>
          </div>

          <div>
            <h4 className="text-background-50/50 text-xs font-semibold uppercase tracking-wider mb-5">订阅爆料</h4>
            <form onSubmit={handleSubscribe} className="flex flex-col gap-3" data-readdy-form="">
              <div className="relative">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  placeholder="输入你的邮箱"
                  className="w-full bg-transparent border-b border-background-50/20 text-background-50 text-sm py-2 pr-10 placeholder:text-background-50/30 focus:outline-none focus:border-accent-500 transition-colors"
                />
                <button
                  type="submit"
                  disabled={status === 'loading'}
                  className="absolute right-0 top-1/2 -translate-y-1/2 w-8 h-8 flex items-center justify-center rounded-full bg-accent-500 text-primary-900 hover:bg-accent-400 transition-colors cursor-pointer"
                >
                  <i className={`text-sm ${status === 'loading' ? 'ri-loader-4-line animate-spin' : 'ri-arrow-right-up-line'}`}></i>
                </button>
              </div>
              <input
                type="text"
                name="website_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="form-anti-spam"
              />
              {status !== 'idle' && (
                <p className={`text-xs ${status === 'success' ? 'text-accent-400' : 'text-red-400'}`}>
                  {statusMsg}
                </p>
              )}
              <p className="text-background-50/30 text-xs">
                订阅即表示同意我们的{' '}
                <a href="#" className="text-background-50/50 hover:text-background-50/80 transition-colors">隐私政策</a>
              </p>
            </form>
          </div>

          <div>
            <h4 className="text-background-50/50 text-xs font-semibold uppercase tracking-wider mb-5">快速导航</h4>
            <ul className="flex flex-col gap-2.5">
              <li><Link to="/" className="text-background-50/60 text-sm hover:text-background-50 transition-colors">首页</Link></li>
              <li><Link to="/category/wanghong-fanche" className="text-background-50/60 text-sm hover:text-background-50 transition-colors">网红翻车</Link></li>
              <li><Link to="/category/cabian-fancha" className="text-background-50/60 text-sm hover:text-background-50 transition-colors">擦边反差</Link></li>
              <li><Link to="/category/mingxing-heiliao" className="text-background-50/60 text-sm hover:text-background-50 transition-colors">明星黑料</Link></li>
              <li><Link to="/about" className="text-background-50/60 text-sm hover:text-background-50 transition-colors">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-background-50/50 text-xs font-semibold uppercase tracking-wider mb-5">关注我们</h4>
            <ul className="flex flex-col gap-2.5">
              <li><a href="#" className="text-background-50/60 text-sm hover:text-background-50 transition-colors" rel="nofollow"><i className="ri-share-forward-line mr-2"></i>微博</a></li>
              <li><a href="#" className="text-background-50/60 text-sm hover:text-background-50 transition-colors" rel="nofollow"><i className="ri-message-3-line mr-2"></i>微信公众号</a></li>
              <li><a href="#" className="text-background-50/60 text-sm hover:text-background-50 transition-colors" rel="nofollow"><i className="ri-video-line mr-2"></i>抖音</a></li>
              <li><a href="#" className="text-background-50/60 text-sm hover:text-background-50 transition-colors" rel="nofollow"><i className="ri-tv-2-line mr-2"></i>B站</a></li>
            </ul>
          </div>
        </div>
      </div>

      <div className="px-4 md:px-6 pb-8">
        <div className="overflow-hidden">
          <div className="font-heading text-[clamp(3rem,10vw,9rem)] font-black text-background-50/[0.04] tracking-tighter leading-none select-none whitespace-nowrap">
            51爆料51爆料51爆料
          </div>
        </div>
      </div>

      <div className="border-t border-background-50/10 px-4 md:px-6 py-5">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3 text-background-50/30 text-xs">
          <p>&copy; {new Date().getFullYear()} 51爆料 版权所有</p>
          <div className="flex items-center gap-4">
            <a href="#" className="hover:text-background-50/50 transition-colors">隐私政策</a>
            <a href="#" className="hover:text-background-50/50 transition-colors">用户协议</a>
            <a href="#" className="hover:text-background-50/50 transition-colors">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}